// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : "";
    // Clear hash immediately so a refresh doesn't re-trigger the exchange.
    try { window.history.replaceState({}, document.title, window.location.pathname); } catch (e) { /* ignore */ }
    if (!sid) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        if (data.token) localStorage.setItem("fms_token", data.token);
        await refresh();
        toast.success(`Welcome, ${data.user?.name || "there"}!`);
        nav("/dashboard", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-center" data-testid="auth-callback">
        <div className="font-display text-2xl text-royal-800">Signing you in…</div>
        <div className="text-xs text-ink/50 mt-2 font-mono-tight">Finishing Google authentication</div>
      </div>
    </div>
  );
}
